export enum SpecificPatternFieldsEnum {
  DeploymentHosts = 'deploymentHosts',
  PatternNotes = 'patternNotes'
}
